<template>
  <b-row
    v-if="subrequestInformations && subrequestInformations.length"
    class="mt-2"
  >
    <b-col>
      <div class="pt-2 pb-2">
        <b-row>
          <b-col
            cols="auto"
            class="d-flex align-items-center"
          >
            <span class="ap-title ap-title__divider">{{ $t('global.supplementaryData') }}</span>
          </b-col>
          <b-col>
            <hr>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col
            v-for="customQuestion in subrequestInformations"
            :key="customQuestion.formQuestion && customQuestion.formQuestion.foqId"
            class="col-lg-4"
            :class="{'col-lg-12':customQuestion.formQuestion.question.queQuestionType === TEXTAREA_QUESTION_TYPE_ID}"
          >
            <div v-if="customQuestion.formQuestion.question.queQuestionType === INPUT_QUESTION_TYPE_ID">
              <b-form-group :label="customQuestion.formQuestion.question.queQuestion">
                <vt-input
                  v-model="customQuestion.sriAnswer"
                  qa="subrequest-additional-input"
                  class="form-control-sm"
                  :disabled="disabled"
                />
              </b-form-group>
            </div>
            <div v-if="customQuestion.formQuestion.question.queQuestionType === MULTISELECT_QUESTION_TYPE_ID">
              <b-form-group :label="customQuestion.formQuestion.question.queQuestion">
                <vt-combo-select
                  v-model="customQuestion.possibleAnswer"
                  track-by="poaId"
                  qa="subrequest-additional-select"
                  :disabled="disabled"
                  :options="customQuestion.formQuestion.question.possibleanswers"
                  label="poaPossibleAnswer"
                  @input="forceUpdate"
                />
              </b-form-group>
            </div>
            <div v-if="customQuestion.formQuestion.question.queQuestionType === DATE_QUESTION_TYPE_ID">
              <b-form-group :label="customQuestion.formQuestion.question.queQuestion">
                <vt-date-picker
                  qa="subrequest-additional-date"
                  :disabled="disabled"
                  :model="customQuestion.sriAnswer"
                  class="form-control-sm p-0"
                  @update="customQuestion.sriAnswer = $event"
                />
              </b-form-group>
            </div>
            <div v-if="customQuestion.formQuestion.question.queQuestionType === TEXTAREA_QUESTION_TYPE_ID">
              <b-form-group :label="customQuestion.formQuestion.question.queQuestion">
                <b-form-textarea
                  id="requestFormRequestClinicalData"
                  v-model="customQuestion.sriAnswer"
                  qa="subrequest-additional-textarea"
                  :disabled="disabled"
                  class="text-box"
                  :rows="2"
                  :max-rows="2"
                />
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { cloneDeep } from 'lodash'
const TEXTAREA_QUESTION_TYPE_ID = 'T'
const MULTISELECT_QUESTION_TYPE_ID = 'S'
const DATE_QUESTION_TYPE_ID = 'D'
const INPUT_QUESTION_TYPE_ID = 'I'
export default {
    name: 'SubRequestCustomForm',
    props: {
        subrequest: { type: Object, required: true },
        laboratoryId: { type: Number },
        disabled: { type: Boolean, required: true }
    },
    data() {
        return {
            subrequestInformations: []
        }
    },
    computed: {
        TEXTAREA_QUESTION_TYPE_ID() {
            return TEXTAREA_QUESTION_TYPE_ID
        },
        MULTISELECT_QUESTION_TYPE_ID() {
            return MULTISELECT_QUESTION_TYPE_ID
        },
        DATE_QUESTION_TYPE_ID() {
            return DATE_QUESTION_TYPE_ID
        },
        INPUT_QUESTION_TYPE_ID() {
            return INPUT_QUESTION_TYPE_ID
        },
        topographicCode() {
            return this.subrequest.topographicCode
        },
        sampleType() {
            return this.subrequest.sampleType
        },
        procedure() {
            return this.subrequest.procedure
        },
        mostLikelyMorphologicCode() {
            return this.subrequest.mostLikelyMorphologicCode
        }
    },
    watch: {
        subrequestInformations: {
            handler() {
                this.$emit('subrequestInformationsChanged', this.subrequestInformations)
            },
            deep: true
        }
    },
    created() {
        this.$watch(() => {
            return `${this.subrequest.topographicCode}/${this.subrequest.sampleType}/${this.subrequest.procedure}/${this.subrequest.mostLikelyMorphologicCode}`
        }, async () => {
            await this.loadCustomForm()
            this.mapSubrequestInformations()
        }, { deep: true })
    },
    mounted() {
        this.loadCustomForm()
    },
    methods: {
        validate() {
            return this.$validator.validate()
        },
        forceUpdate() {
            this.$forceUpdate()
        },
        mapSubrequestInformations() {
            if (this.subrequestInformations) {
                this.subrequestInformations = cloneDeep(this.subrequestInformations.filter(customQuestion => customQuestion.formQuestion))
            }
        },
        async loadCustomForm() {
            if (!this.subrequest) {
                return
            }
            const procedureId = this.procedure?.id
            const sampleTypeId = this.sampleType?.id
            const topographicCodeId = this.topographicCode?.id
            const mostLikelyMorphologicCodeId = this.mostLikelyMorphologicCode?.id
            if (procedureId && sampleTypeId && topographicCodeId) {
                const [error, response] = await this.toCall(commonSampleClassificationService.getCommonFormsSampleClassificationsByLaboratory({
                    laboratoryId: this.laboratoryId,
                    procedureId: procedureId,
                    sampleTypeId: sampleTypeId,
                    topographicCodeId: topographicCodeId,
                    mostLikelyMorphologicCodeId: mostLikelyMorphologicCodeId
                }))

                if (error) {
                    this.showErrorModalGlobal()
                    return
                }
                this.subrequestInformations = this.mergeSubrequestInformations(response.formQuestions, this.subrequest.subrequestInformations)
            } else {
                this.subrequestInformations = []
            }
        },
        mergeSubrequestInformations(newInfo, oldInfo) {
            return newInfo.map(newFormQuestion => {
                const matchingOldInfo = oldInfo && oldInfo.find(oldFormQuestion => oldFormQuestion.formQuestion.question.queId === newFormQuestion.question.queId)
                if (matchingOldInfo) {
                    const mergedInfo = { ...matchingOldInfo }
                    mergedInfo.formQuestion = newFormQuestion
                    return mergedInfo
                }
                return { formQuestion: newFormQuestion }
            })
        }
    }
}
</script>

<style scoped>

</style>
